import { ampli } from '~shared/analytics';

import { ClientAuthEvent } from '@breezeventures/web-ph-client-auth/event-tracker-types';

export const trackAuthEvents = (event: ClientAuthEvent, phone: string) => {
  if (event.name === 'client_auth_otp_confirm_click') {
    ampli.mpAuthOtpScreenNextClick({ phone });
  }
  if (event.name === 'client_auth_otp_resend_click') {
    ampli.mpAuthOtpResendClick({ phone });
  }
  if (event.name === 'client_auth_otp_error') {
    ampli.mpAuthOtpError({ phone });
  }
};
